import { module } from 'modujs';
import { queryClosestParent } from '../utils/html'
import { gsap, Draggable, InertiaPlugin } from 'gsap/all'
gsap.registerPlugin(Draggable, InertiaPlugin);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.proxy = this.$('proxy')[0];
        this.inner = this.$('inner')[0];

        this.compute();
        this.initIntersectionObserver();

        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)

        this.viewportWidth = window.innerWidth;
        if(this.viewportWidth < 1000) {
            return;
        }

        this.initDraggable();
    }

    initIntersectionObserver() {
        let options = {
          root: window.innerWidth < 1000 ? null : this.el,
          rootMargin: '-1px -1px -1px -1px',
          threshold: 0
        }

        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                const id = entry.target.getAttribute('data-module-home-grid-item')
                if(entry.isIntersecting) {
                    this.call('enter', null, 'HomeGridItem', id);
                } else {
                    this.call('leave', null, 'HomeGridItem', id);
                }
            });

        }, options);

        for(const item of Array.from(this.$('item'))) {
            observer.observe(item);
        }
    }

    initDraggable() {
        let that = this;

        const updateDrag = function() {
            gsap.set(that.inner, {
                x: this.x,
                y: this.y
            })
        };

        this.drag = Draggable.create(this.proxy, {
            type: 'x,y',
            edgeResistance: 0.5,
            bounds: this.bounds,
            trigger: this.el,
            inertia: true,
            throwResistance: 2000,
            onDrag: updateDrag,
            onThrowUpdate: updateDrag,
            allowEventDefault: true,
            onPress: () => {
                this.el.classList.add('is-dragging')
            },
            onRelease: () => {
                this.el.classList.remove('is-dragging')
            },
            onDragStart: () => {
                this.el.classList.add('is-dragging')
            },
            onDragEnd: () => {
                this.el.classList.remove('is-dragging')
            }
        })[0]

        // console.log(this);
    }
    
    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                // console.log((this.viewportWidth >= 1000 && window.innerWidth < 1000) || (this.viewportWidth < 1000 && window.innerWidth >= 1000));
                if((this.viewportWidth >= 1000 && window.innerWidth < 1000) || (this.viewportWidth < 1000 && window.innerWidth >= 1000)) {
                    window.location.reload();
                }

                this.onResize()
                this.resizeTick = false
            })
        }
    }

    onResize() {
        this.compute();

        if(this.drag && this.drag.applyBounds) {
            this.drag.applyBounds(this.bounds);
        }
    }

    compute() {
        const innerBCR = this.inner.getBoundingClientRect()

        this.bounds = {
            minX: -innerBCR.width/2 + window.innerWidth/2,
            maxX: innerBCR.width/2 - window.innerWidth/2,
            minY: -innerBCR.height/2 + window.innerHeight/2,
            maxY: innerBCR.height/2 - window.innerHeight/2
        }
    }

    destroy() {
        if(this.drag && this.drag.kill) {
            this.drag.kill()
            this.drag = null
            delete this.drag;
        }
    }
}
